export const dateOptions = [
  { label: "Custom", value: "custom" },
  { label: "Last Week", value: "lastWeek" },
  { label: "This Month", value: "thisMonth" },
  { label: "Last 3 Months", value: "last3Months" },
  { label: "Last 6 Months", value: "last6Months" },
  { label: "Last 12 Months", value: "last12Months" },
  { label: "Last Calendar Year", value: "lastCalendarYear" },
  //{ label: "Include All Dates", value: "includeAllDates" },
];
